_incrementImpressionCount